import '@babel/polyfill';
import Vue from 'vue';

// Bug tracking
import LogRocket from 'logrocket';
LogRocket.init('sugcku/film-permits', {
    network: {
        requestSanitizer: (request) => {
            // if the url contains 'ignore'
            if (request.url.toLowerCase().indexOf('token') !== -1) {
                // scrub out the body
                request.body = 'DATA PROTECTED';
            }

            return request;
        },
    },
});

import App from './App.vue';
import VueAnalytics from 'vue-analytics';
import { router } from './router';
import store from '@/store';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faCheck,
    faArrowRight,
    faArrowLeft,
} from '@fortawesome/free-solid-svg-icons';
import { faSave } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import '@/styles/main.scss';
import dayjs from 'dayjs';

//bootstrap-vue
import { BootstrapVue} from 'bootstrap-vue'
import "bootstrap/dist/css/bootstrap.css";
import 'bootstrap-vue/dist/bootstrap-vue.css'

//vue-chartjs
import VueCharts from "vue-chartjs";

// NodeList.forEach polyfill for IE11
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}

// Fontawesome bits and bobs
library.add(faCheck, faSave, faArrowRight, faArrowLeft);
Vue.component('font-awesome-icon', FontAwesomeIcon);

// Google analytics
Vue.use(VueAnalytics, {
    id: 'UA-114904878-6',
    router,
});

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Make VueCharts available throughout your project
Vue.use(VueCharts)

Vue.config.productionTip = false;

// Make the dayjs function available at the template level
Vue.prototype.dayjs = dayjs;

Vue.directive('focus', {
    // When the bound element is inserted into the DOM...
    inserted: function(el) {
        // Focus the element
        const { x, y } = el.getBoundingClientRect();
        window.scrollTo(x, y);
    },
});

Vue.directive('popupcalc', {
    // When the bound element is inserted into the DOM...
    inserted: function(el, binding) {
        // remove class from last popup, using the method twice for IE11 support
        el.classList.remove('picker-top');
        el.classList.remove('picker-bottom');

        const { height: pickerHeight } = el.getBoundingClientRect();
        const { height: inputHeight, top: inputTop } = document
            .querySelector(`#${binding.value}`)
            .getBoundingClientRect();
        const roomAbove = inputTop > pickerHeight ? true : false;
        if (roomAbove) {
            el.classList.add('picker-top');
            el.style.top = `-${pickerHeight + 16}px`;
        } else {
            el.classList.add('picker-bottom');
            el.style.top = `${inputHeight + 16}px`;
        }
    },
    componentUpdated: function(el, binding) {
        // remove class from last popup, using the method twice for IE11 support
        el.classList.remove('picker-top');
        el.classList.remove('picker-bottom');
        el.style.top = '0px';
        const { height: pickerHeight } = el.getBoundingClientRect();
        const { height: inputHeight, top: inputTop } = document
            .querySelector(`#${binding.value}`)
            .getBoundingClientRect();
        const roomAbove = inputTop > pickerHeight ? true : false;
        if (roomAbove) {
            el.classList.add('picker-top');
            el.style.top = `-${pickerHeight + 16}px`;
        } else {
            el.classList.add('picker-bottom');
            el.style.top = `${inputHeight + 16}px`;
        }
    },
});

Vue.mixin({
    methods: {
        _errorsExist() {
            return this.$children.filter((child) => child.hasError).length > 0;
        },
    },
});

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');

